exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-add-filter{position:relative}.c-add-filter_item-label{max-width:184px;overflow:hidden;text-overflow:ellipsis}.c-add-filter>.m-dropdown-wrapper{top:45px}.c-add-filter>.m-dropdown-wrapper>.m-dropdown-list li svg{opacity:1}", ""]);

// exports
